import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IChooseItems } from 'core/api/dto/BuffetDishDto'
import { useArchiveMultipleStandardAiDatasetsMutation } from 'core/api/StandardAiDataset'
import {
  AppNotification,
  NotificationType,
} from 'components/notification/Notification'
import { useDeleteDebounce } from 'utils/useDeleteDebounce'

interface UseDeleteDishResponse {
  deletePopup: boolean
  onDeletePopupHandler: () => void
  onDeleteHandler: () => void
  closeDeletePopup: () => void
}

export const useDeleteAiDish = (
  chooseItems: IChooseItems | null,
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>,
): UseDeleteDishResponse => {
  const [deletePopup, setDeletePopup] = useState(false)
  const [archiveMultipleStandardAiDatasets] =
    useArchiveMultipleStandardAiDatasetsMutation()
  const { t } = useTranslation()

  const deleteDish = () => {
    if (!!chooseItems) {
      archiveMultipleStandardAiDatasets({
        standartAiDatasetIds: Object.keys(
          Object.fromEntries(
            Object.entries(chooseItems).filter((e) => e.includes(true)),
          ),
        ).map((item) => Number(item)),
      })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Выбранные данные успешно удалены!'),
            type: NotificationType.success,
          })
          setChooseItems(null)
        })
    }
  }

  const [onDeleteHandler] = useDeleteDebounce({
    fn: deleteDish,
    extraText: t('Выбранные вами данные будут удалены на сервере!'),
  })

  const closeDeletePopup = () => setDeletePopup(false)
  const openDeletePopup = () => setDeletePopup(true)

  return {
    deletePopup,
    onDeletePopupHandler: openDeletePopup,
    onDeleteHandler,
    closeDeletePopup,
  }
}
